$shm_hitalama_map_borderwidth $mol_view
	sub /
		<= Search $mol_search
			hint @ \Border width
			query? <=> border_width_selected? \
			anchor_content /
				<= Border_width_wrap $mol_view
					sub /
						<= Border_width $mol_number
							minimal_width 64
							value? <=> border_width? 1
							Dec null
							Inc null
			suggests <= border_width_suggests /string
	border_width_options /number
		1
		4
		10
